"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ratio = require("promo-js/lib/services/ratio/ratio.service");

var _default = _propTypes.default.oneOf([_ratio.RATIOS_BY_NAME.square.name, _ratio.RATIOS_BY_NAME.wide.name, _ratio.RATIOS_BY_NAME.vertical.name]);

exports.default = _default;